import { SEATING_STRATEGY_TYPE, SeatingStrategyBase } from "./seating-strategy";

export class SeatingStrategyPenalizeBookedTables extends SeatingStrategyBase {
  constructor(matchScoreModifier, policyLevel) {
    super(SEATING_STRATEGY_TYPE.PenalizeBookedTables, matchScoreModifier, 0, policyLevel);
  }

  toString() {
    return `${SEATING_STRATEGY_TYPE.nameof(this.seatingStrategyType)} (${this.matchScoreModifier} points)`;
  }

  isValid() {
    return true;
  }

  static fromJSON(json) {
    if (!json) return undefined;

    return Object.assign(new SeatingStrategyPenalizeBookedTables(), json);
  }
}


